import React from 'react';

const Switch = ({checked, setChecked}) => {
    return (
        <div onClick={() => setChecked(state => !state)}
             className={`w-24 h-10 rounded-full relative cursor-pointer duration-200 m-auto  ${checked ? 'bg-gray-400' : 'bg-green-400'}`}>
            <div
                className={`w-8 h-8 bg-white border absolute top-1/2 -translate-y-1/2 rounded-full duration-200 left-1/2 ${checked ? '-translate-x-full' : '-translate-x-0'}`}>

            </div>
        </div>
    );
};

export default Switch;